import React from 'react'
import {Drawer, Space, Button, Flex, Tag, Card, Divider, App} from "antd";
import {SettingOutlined, NumberOutlined, ArrowLeftOutlined, FileImageOutlined} from "@ant-design/icons";
import {Form, useDynamicForm} from "kaiju.core";
import i18n from "i18next";


interface Props {
    open: boolean
    attrId: string
    appId: string
    collectionId: string
    onClose: () => void
    onEdit: () => void
}

export const AttributeEdit: React.FC<Props> = (props) => {
    const handleClose = () => {
        props.onEdit()
        props.onClose()
    }
    const {notification} = App.useApp();

    const [store] = useDynamicForm({
        autoLoad: true,
        loadRequest: {
            method: 'ContentTypeBuilder.collection.attribute.get',
            params: {
                collection: props.collectionId,
                id: props.attrId
            }
        },
        isNested: true,
        saveDiff: false,
        loadExtraParams: {
            application: props.appId,
        },
        saveRequest: {
            method: 'ContentTypeBuilder.collection.attribute.update',
            params: {
                collection: props.collectionId,
            }
        },
        successCallback: (response: any) => {
            notification.success({
                message: i18n.t('common.updated'),
                placement: 'topRight',
            });
            handleClose()
        }
    });

    return <>
        <Drawer
            title={
                <>
                    <span>{i18n.t("attribute.create-new")}</span>
                </>}
            onClose={handleClose}
            width={900}
            open={props.open}
            size={"large"}
        >
            <Form store={store.formStore}>
                <Space>
                    <Button onClick={() => {
                        store.submit()
                    }} type="primary">
                        {i18n.t("common.save")}
                    </Button>
                </Space>
            </Form>
        </Drawer>
    </>
}
